import { render } from "./UiDatePicker.vue?vue&type=template&id=05bcf7c0&ts=true"
import script from "./UiDatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiDatePicker.vue?vue&type=script&lang=ts&setup=true"

import "./UiDatePicker.vue?vue&type=style&index=0&id=05bcf7c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiDatePicker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05bcf7c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05bcf7c0', __exports__)) {
    api.reload('05bcf7c0', __exports__)
  }
  
  module.hot.accept("./UiDatePicker.vue?vue&type=template&id=05bcf7c0&ts=true", () => {
    api.rerender('05bcf7c0', render)
  })

}


export default __exports__